import { Result } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledResult = styled(Result)`
    margin: auto;
`;

export default function NonExistentEntityPage() {
    return (
        <StyledResult
            status="404"
            title="Not Found"
            subTitle="Sorry, we are unable to find this entity in Data Catalog"
        />
    );
}
